// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GiftcardResponse

import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { hydratePayment, type Payment, type PaymentApiResponse } from './payment.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type GiftcardApiResponse = {
	id: string;
	code: string;
	buyingPrice: number;
	initialAmount: number;
	remainingAmount: number;
	customerId: string | null;
	customer: CustomerApiResponse | null;
	issueAt: string;
	expiresAt: string;
	businessId: string;
	memo: string | null;
	label: string | null;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	buyer: CustomerApiResponse | null;
	message: string | null;
	giftcardOrderId: number | null;
	payment: PaymentApiResponse | null;
	archivedAt: string | null;
};

export type Giftcard = {
	id: string;
	code: string;
	buyingPrice: number;
	initialAmount: number;
	remainingAmount: number;
	customerId: string | null;
	customer: Customer | null;
	issueAt: DateTime;
	expiresAt: DateTime;
	businessId: string;
	memo: string | null;
	label: string | null;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	buyer: Customer | null;
	message: string | null;
	giftcardOrderId: number | null;
	payment: Payment | null;
	archivedAt: DateTime | null;
};

export function hydrateGiftcard(data: GiftcardApiResponse): Giftcard {
	return {
		...data,
		customer: data.customer ? hydrateCustomer(data.customer) : null,
		issueAt: DateTimefromISO(data.issueAt)!,
		expiresAt: DateTimefromISO(data.expiresAt)!,
		buyer: data.buyer ? hydrateCustomer(data.buyer) : null,
		payment: data.payment ? hydratePayment(data.payment) : null,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}